import { APIClient } from "@/utils/httpClient";
import { APIError } from "@/errors";

export const executeApiCall = async (
    campaignId: string,
    apiConfigID: string,
    userId?: string
) => {
    const response = await APIClient.post(
        `/campaigns/${campaignId}/apiConfigs/${apiConfigID}/execute`,
        {
            userId,
        }
    );
    if (response.success) {
        return response.data;
    } else {
        throw new APIError(response.message);
    }
};
